import {
  call, put, takeEvery, takeLatest, takeLeading,
} from 'redux-saga/effects';
import userAPI from '../../../../user/api/UserAPI';
import { FETCH_USER_PRODUCT_SELECTIONS_REQUEST, DELETE_USER_PRODUCT_SELECTION_REQUEST } from '../../../../user/redux/actions/types/UserActionTypes';
import {
  deleteUserProductSelectionSuccessActionCreator,
  deleteUserProductSelectionFailureActionCreator,
  fetchUserProductSelectionsFailureActionCreator,
  fetchUserProductSelectionsSuccessActionCreator,
} from '../../../../user/redux/actions/UserActions';
import mailClassesAPI from '../../api/MailClassesApi';
import {
  fetchMailClassesFailure,
  fetchMailClassesSuccess,
} from '../actions/ProductActions';
import { FETCH_MAIL_CLASSES } from '../actions/types/ProductActionTypes';

function* mailClassesWorker() {
  try {
    const mailClassesResponse = yield call(mailClassesAPI.fetchMailClasses);

    yield put(fetchMailClassesSuccess(mailClassesResponse.data));
  } catch (error) {
    yield put(fetchMailClassesFailure(error));
  }
}

function* fetchUserProductSelectionsWorker() {
  try {
    const userProductSelectionsResponse = yield call(userAPI.getUserProductSelections);
    const selections = userProductSelectionsResponse.data;

    yield put(fetchUserProductSelectionsSuccessActionCreator(selections));
  } catch (error) {
    yield put(fetchUserProductSelectionsFailureActionCreator(error));
  }
}

function* deleteUserProductSelectionsWorker(action) {
  try {
    const name = action.payload;
    const userProductSelectionsDeleteResponse = yield call(
      userAPI.deleteUserProductSelection,
      name,
    );
    const selections = userProductSelectionsDeleteResponse.data;
    yield put(deleteUserProductSelectionSuccessActionCreator(selections));
  } catch (error) {
    yield put(deleteUserProductSelectionFailureActionCreator(error));
  }
}

function* mailClassesWatcher() {
  yield takeLeading(FETCH_MAIL_CLASSES, mailClassesWorker);
  yield takeLeading(FETCH_USER_PRODUCT_SELECTIONS_REQUEST, fetchUserProductSelectionsWorker);
  yield takeEvery(DELETE_USER_PRODUCT_SELECTION_REQUEST, deleteUserProductSelectionsWorker);
}

export default mailClassesWatcher;
